document.addEventListener('click', async function (event) {
  const shareBtn = event.target.closest('.btto-cart-share-btn');
  const closeBtn = event.target.closest('.btto-share-cart-modal__close');
  const overlay = event.target.closest('.btto-share-cart-modal__overlay');
  const copyBtn = event.target.closest('.btto-share-cart-copy');

  const modal = document.querySelector('.btto-share-cart-modal');
  const input = document.querySelector('.btto-share-cart-link');

  if (shareBtn) {
    shareBtn.disabled = true;
    shareBtn.textContent = 'Loading...';

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      const saveResponse = await fetch('https://btto-share-cart.imichaelfsh.workers.dev/save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: cart.items.map(function (item) {
            return {
              id: item.variant_id,
              quantity: item.quantity,
              properties: item.properties || {}
            };
          })
        })
      });

      const data = await saveResponse.json();

      if (!data.success || !data.token) {
        throw new Error('Create share link failed');
      }

      input.value = window.location.origin + '/pages/cart?token=' + data.token;
      modal.hidden = false;
    } catch (error) {
      alert('Share cart failed. Please try again.');
      console.error(error);
    } finally {
      shareBtn.disabled = false;
      shareBtn.textContent = 'Share';
    }
  }

  if (closeBtn || overlay) {
    modal.hidden = true;
  }

  if (copyBtn) {
    input.select();
    input.setSelectionRange(0, 99999);
    await navigator.clipboard.writeText(input.value);
    copyBtn.textContent = 'Copied';
    setTimeout(function () {
      copyBtn.textContent = 'Copy Link';
    }, 1500);
  }
});
document.addEventListener('DOMContentLoaded', async function () {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  if (!token) return;
  if (!window.location.pathname.includes('/pages/cart')) return;

  document.body.insertAdjacentHTML(
    'afterbegin',
    '<div class="btto-cart-restore-loading">Restoring your cart...</div>'
  );

  try {
    const loadResponse = await fetch(
      'https://btto-share-cart.imichaelfsh.workers.dev/load?token=' + encodeURIComponent(token)
    );

    const data = await loadResponse.json();

    if (!data.items || !Array.isArray(data.items)) {
      throw new Error('Invalid shared cart');
    }

    await fetch('/cart/clear.js', {
      method: 'POST'
    });

    for (const item of data.items) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: item.id,
          quantity: item.quantity,
          properties: item.properties || {}
        })
      });
    }

    window.location.href = '/cart';
  } catch (error) {
    console.error(error);
    document.querySelector('.btto-cart-restore-loading').textContent =
      'Shared cart could not be restored.';
  }
});